export type TerraceTypeInfo = {
  title: string;
  description: string;
  note?: string;
};

export const terraceTypeInfo = {
  hero: {
    title: "Hero Banner",
    description:
      "Highlight key visuals with a large banner and call-to-action button.",
    note: "When turned on, the Hero Banner is always pinned to the top of the page.",
  },
  statement: {
    title: "Statement",
    description: "Feature key messages with an image and button for emphasis.",
  },
  spotlight: {
    title: "Spotlight",
    description: "Display engaging visuals with buttons for key initiatives.",
  },
  shortcuts: {
    title: "Shortcuts",
    description: "Shortcut icons for easy access to essential resources.",
  },
  news: {
    title: "News",
    description:
      "Share important updates and announcements with your community.",
  },
  about: {
    title: "About",
    description:
      "Introduce your page with text and an optional image or video.",
  },
  events: {
    title: "Events",
    description: "Keep everyone informed about important dates.",
  },
  accordion: {
    title: "Accordion",
    description: "Organize detailed information in collapsible sections.",
  },
  media: {
    title: "Gallery",
    description: "Showcase photos and videos from recent events or activities.",
  },
  files: {
    title: "Files & Folders",
    description: "List & Preview connected cloud files and folders.",
  },
  links: {
    title: "Links",
    description: "Easily organize links to important resources and websites.",
  },
  staff: {
    title: "Staff",
    description: "Showcase staff members with easy-to-find profile cards.",
  },
  html: {
    title: "HTML",
    description: "Embed widgets or custom code.",
  },
  map: {
    title: "Map",
    description:
      "Display your location with an interactive map for easy navigation.",
    note: "When turned on, the Map is always pinned to the bottom of the page.",
  },
  shop: {
    title: "Spirit Gear",
    description: "Show a few items from your shop.",
  },
} as const satisfies Record<string, TerraceTypeInfo>;

export type TerraceType = keyof typeof terraceTypeInfo;
